import Topbar from './components/Topbar';
import Header from './components/Header';
import Hero from './components/Hero';
import CategoryStrip from './components/CategoryStrip';
import ComoPides from './components/ComoPides';
import Cobertura from './components/Cobertura';
import QueLlevamos from './components/QueLlevamos';
import TrustStrip from './components/TrustStrip';
import Visitanos from './components/Visitanos';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';
import Footer from './components/Footer';
import StickyMobileBar from './components/StickyMobileBar';

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-md-bg">
      <Topbar />
      <Header />
      <main className="flex-1">
        <Hero />
        <CategoryStrip />
        <ComoPides />
        <Cobertura />
        <QueLlevamos />
        <TrustStrip />
        <Visitanos />
        <FAQ />
        <CTAFinal />
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}